import React from 'react';
import { useRecoilValueLoadable } from 'recoil';
import { getLogotype, getMerchantName } from '../stateAtoms/cart';

function CartHeader({ checkoutId }) {
  const merchantNameResult = useRecoilValueLoadable(getMerchantName(checkoutId));
  const logotypeResult = useRecoilValueLoadable(getLogotype(checkoutId));
  const bothHasError = merchantNameResult.state === 'hasError' && logotypeResult.state === 'hasError';
  if (bothHasError) {
    return '';
  }
  return (
    <header className="d-flex flex-row pt-4 mb-3 align-items-center">
      {merchantNameResult.state === 'hasValue' && <h1 className="m-0 mr-2">{merchantNameResult.contents.tradeName}</h1>}
      {logotypeResult.state === 'hasValue' && (
        <img
          style={{ maxHeight: 60 }}
          src={`data:${logotypeResult.contents.mediaType};base64,${logotypeResult.contents.logotype}`}
          alt="logotype"
          className="ml-auto"
        />
      )}
    </header>
  );
}

export default CartHeader;
